import Swiper from 'swiper/bundle';

import '../block/becomeSpeaker';
import '../block/sliderCursor';
import options from '../block/swiperOptions';

window.festival = {
    init: function() {
        festival.swipers();
    },

    swipers: function() {

        // Программная дирекция
        new Swiper('.swiper-2', $.extend(options, {
            slidesPerView: 'auto',
            spaceBetween: 16,
            breakpoints: {
                768: {
                    spaceBetween: 20
                }
            }
        }));

        // Совет
        new Swiper('.swiper-3', $.extend(options, {
            slidesPerView: 'auto',
            spaceBetween: 16,
            breakpoints: {
                768: {
                    spaceBetween: 20
                }
            }
        }));

        // Карточки файлов
        new Swiper('.swiper-1', $.extend(options, {
            slidesPerView: 'auto',
            spaceBetween: 16,
            breakpoints: {
                768: {
                    spaceBetween: 20
                }
            }
        }));
    }

}

$(festival.init)